import Store from '@ember-data/store';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import { sortByProperties } from 'donor-elf-web/lib/array-utils';

export default class AllFundsIndexRoute extends Route {
  @service declare navbarSettings: NavbarSettingsService;
  @service declare store: Store;

  beforeModel() {
    this.navbarSettings.title = 'All Funds';
  }

  async model() {
    let journalGroups = sortByProperties(
      (await this.store.query('all-funds/journal-group', {})).slice(),
      ['createdAt:desc'],
    );

    return {
      journalGroups,
    };
  }
}
